import BigNumber from 'bignumber.js';
import { Formatter } from 'recharts/types/component/DefaultTooltipContent';

export const requestsValueFormatter: Formatter<string, string> = (
  value: string,
) => {
  // Format the numeric value with proper separators
  const formattedValue = new BigNumber(value).toFormat();

  return [formattedValue, 'Requests'];
};
